import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class InvalidDomainForUserErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [
                {
                    'code': 'invalid_user_domain',
                    'text': 'Invalid domain'
                }
            ]
        }
    }

    static errorCodes() {
        return ['invalid_user_domain'];
    }
}